import { createContext } from "react";

import type { UseOnlineReturn } from "@/providers/_hooks/useOnline";

export const OnlineContext = createContext<UseOnlineReturn | undefined>(
  undefined,
);
